import _ from 'lodash'

export default (api) => ({
  actions: {
    getItems ({ dispatch }, payload) {
      return dispatch('_getItems', payload)
    },
    _getItems ({ commit, getters }, payload) {
      const requestId = _.uniqueId('odataRequest_')
      commit('updateRequestId', requestId)

      return api.getItems(payload).then(response => {
        if (getters.loadItemRequestId === requestId) {
          return {
            items: response.data.items,
            totalCount: response.data.count
          }
        }
      })
    },
  },
  mutations: {
    updateRequestId (state, data) {
      state.loadItemRequestId = data
    },
  },
  getters: {
    loadItemRequestId (state) { return state.loadItemRequestId },
  },
  state: {
    loadItemRequestId: null,
  },
})
